import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router, UrlSerializer } from '@angular/router';
import { map, Observable, Subscriber, throwError } from 'rxjs';
// import { environment } from 'src/environments/environment';
import { catchError, finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from './loading.service';
import { NavigationService } from './navigation.service';
import { AuthService } from '../../auth/service/auth.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  apiHost: any;
  header: any;

  private authService!: AuthService;

  constructor(
    private http: HttpClient,
    private router: Router,
    private serializer: UrlSerializer,
    private toast: ToastrService,
    private loadingService: LoadingService,
    private navigationService: NavigationService,
    private injector: Injector) {
    this.apiHost = environment.apiHost;
  }

  // setIpAddress() {
  //   return new Observable<String>((observer) => {
  //     this.http.get('assets/files/ip.json', { responseType: 'text' }).subscribe((data) => {
  //       const ipObject = JSON.parse(data);
  //       observer.next(ipObject['ip']);
  //       observer.complete();
  //     });
  //   });
  // }

  post<T>(url: any, postParams: any): Observable<any> {
    this.loadingService.show();
    return this.http
      .post<any>(this.apiHost + url, postParams)
      .pipe(catchError(this.handleError.bind(this)))
      .pipe(finalize(() => this.loadingService.hide()));
  }

  get<T>(url: any, queryParams: any = null): Observable<any> {
    this.loadingService.show();
    if (queryParams) {
      queryParams = this.router.createUrlTree([''], {
        queryParams: queryParams,
      });
      queryParams = this.serializer.serialize(queryParams);
      queryParams = queryParams.replace('/', '');
    }
    if (queryParams)
      return this.http
        .get<any>(this.apiHost + url + queryParams)
        .pipe(catchError(this.handleError.bind(this)))
        .pipe(finalize(() => this.loadingService.hide()));
    else
      return this.http
        .get<any>(this.apiHost + url)
        .pipe(catchError(this.handleError.bind(this)))
        .pipe(finalize(() => this.loadingService.hide()));
  }

  getWithoutHeader(url: any): Observable<any> {
    return this.http.get<any>(this.apiHost + url);
  }

  put<T>(url: any, postParams: any): Observable<any> {
    this.loadingService.show();
    return this.http
      .put<any>(this.apiHost + url, postParams)
      .pipe(catchError(this.handleError.bind(this)))
      .pipe(finalize(() => this.loadingService.hide()));
  }

  delete<T>(url: any) {
    this.loadingService.show();
    return this.http
      .delete<any>(this.apiHost + url)
      .pipe(catchError(this.handleError.bind(this)))
      .pipe(finalize(() => this.loadingService.hide()));
  }

  getAuthService() {
    if (!this.authService) {
      this.authService = this.injector.get(AuthService);
    }
    return this.authService;
  }
  handleError(error: HttpErrorResponse) {
    let errorMessage = 'An unknown error occurred!';

    // Server-side error
    switch (error.status) {
      case 0:
        errorMessage = 'Backend Server is down. Please try again later.';
        break;
      case 404:
        errorMessage = 'Invalid request.';
        break;
      case 500:
        errorMessage = 'Internal server error.';
        break;
    }

    if (![0, undefined].includes(error.status)) {
      // let msg = error && error.message ? error.message : 'Something bad happened; please try again later.';
      if (error && error.error && error.error.message) {
        errorMessage = error.error.message;
      }

      if (error && error.status && error.status == 401) {
        // IF TOKEN EXPIRED.
        if (error.error.code == 40103) {
          this.getAuthService().logout();
        }
        // this.navigationService.navigateTo('/');
        // this.toast.error(errorMessage);
      }
    }

    // BAD REQUEST
    this.toast.error(errorMessage);

    // return throwError(() => new Error(errorMessage));
    return throwError(() => errorMessage);
  }
}
